export const PYCRAY_FORGE_YOUTUBE_URL =
  "https://www.youtube.com/@PyCrayForge?sub_confirmation=1";

export const PYCRAY_FORGE_YOUTUBE_LABEL = "PyCray Forge YouTube";
